import { Controller } from "@hotwired/stimulus";
import { isEnterKey } from "../../utils/inputs_utils";
import { appendUrlSearchParams } from "../../utils/misc";
import { handleOtpFlow } from "../../utils/business_utils";

export default class extends Controller {
  static targets = ["form", "emailInput", "defaultInputsContainer", "otpInput", "otpInputContainer"];
  static values = { verifyOtpUrl: String };

  catchEnterKeyPress(e) {
    if (isEnterKey(e.keyCode)) {
      this.verifyOtp(e);
    }
  }

  verifyOtp(e) {
    e.preventDefault();

    const isFormValid = $(this.formTarget).parsley().validate();
    if (!isFormValid) {
      return;
    }

    const url = this._buildVerifyOtpUrl(this.verifyOtpUrlValue);
    handleOtpFlow(url, {
      onOtpRequired: () => this._displayOtpInput(),
      onOtpNotRequired: () => this.formTarget.submit(),
    });
  }

  _buildVerifyOtpUrl(baseUrl) {
    return appendUrlSearchParams(baseUrl, { email: this.emailInputTarget.value });
  }

  _displayOtpInput = () => {
    this.otpInputTarget.required = true;
    this.defaultInputsContainerTarget.classList.add("hidden");
    this.otpInputContainerTarget.classList.remove("hidden");
  };
}
